import React, { useState, useEffect, useCallback, useRef, Fragment } from 'react';
import TableWrapper from '../../components/Grid';
import AddEligibilityDrawer from './AddEligibilityDrawer';
import AddScheduleDrawer from './AddScheduleDrawer';
import { Avatar, Col, ColorPicker, Image, Input, Row, Space, Tabs, Select, Switch, Collapse } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { useForm, Controller } from 'react-hook-form';
import camera from '../../assets/images/camera.png';
import NewFilterBar from '../../components/NewFilterBar';
import { FaCamera, FaEye } from 'react-icons/fa';
import { Button } from 'antd';
import { ApiCaller, Colors, Utils } from '../../config';
import { useDispatch, useSelector } from 'react-redux';
import {
    AppAction,
    SettingAction,
    UserManagementAction,
} from '../../store/actions';

const DAYS_OF_WEEK = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
import { Spin } from 'antd';
import ActionDropdown from '../../components/DropDown/actiondropdown';
import ScheduleDetailDrawer from './ScheduleDetailDrawer';
import EligibilityDetailDrawer from './EligibilityDetailDrawer';
import SuperAdminWorkWeekSettings from './SuperAdminWorkWeekSettings';
import CompanyWorkWeekSettings from './CompanyWorkWeekSettings';
import ScheduledReportsSettings from './ScheduledReportsSettings';
import ContactDirectoryPage from '../ContactDirectory/ContactDirectoryPage';
import PatrolSettingsPage from './PatrolSettings/PatrolSettingsPage';
import { FaTrash } from 'react-icons/fa';
import CustomModal from '../../components/Modal/CustomModal';
import { useMutation, useQuery } from 'react-query';
import {
    getEligibiity,
    getSchedules,
    getUserRoles,
} from '../../config/getApis';
import useColors from '../../hooks/useColors';
import { yupResolver } from '@hookform/resolvers/yup';
import { UserDetail } from '../../config/Schema';
import LabelWithField from '../../components/LabelWithField';
import TextnFilters from '../../components/TextnFilters';
import { Modal } from '../../components';
import { MdEditDocument } from "react-icons/md";

const { TabPane } = Tabs;

const Settings = () => {
    const { colorPrimary, colorSecondary } = useColors();
    const userData = useSelector(
        (state) => state?.UserManagementReducer?.UserData,
    );

    console.log('hey', userData);

    // const schema = UserDetail;
    const dispatch = useDispatch();
    const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);
    const [recordToDelete, setRecordToDelete] = useState(null);
    const [imageID, setImageID] = useState(null);
    const [loading, setLoading] = useState(false);

    const { control, handleSubmit, reset, setValue, watch } = useForm({
        // resolver: yupResolver(schema),
    });

    const user = useSelector((state) => state.AppReducer?.user);
    const companyLogo = Utils.getBrandLogoUrl(user?.guardCompany);
    const isRole = user?.userRole[0];
    console.log('hath hath', user);

    const { scheduleData, loader, elegibilityData } = useSelector(
        (state) => state?.SettingReducer,
    );
    let schedules = scheduleData?.data?.data;
    let schedulesPagination = scheduleData?.data?.paginate;

    let elegibilities = elegibilityData?.data?.data;
    let elegibilityPagination = elegibilityData?.data?.paginate;

    const dateFormatFromStore = useSelector((state) => state.AppReducer?.dateFormat);
    const timeFormatFromStore = useSelector((state) => state.AppReducer?.timeFormat);
    const weekConfigFromStore = useSelector((state) => state.AppReducer?.weekConfig) || { startDay: 'Sunday', endDay: 'Saturday' };

    const [weekStartDay, setWeekStartDay] = React.useState(weekConfigFromStore.startDay || 'Sunday');
    const [weekEndDay, setWeekEndDay] = React.useState(weekConfigFromStore.endDay || 'Saturday');

    const { data: eligibilitiesData } = useQuery('eligibility', getEligibiity);
    const { data: schedulesData } = useQuery('schedules', getSchedules);
    const { data: rolesData } = useQuery('roles', getUserRoles);
    const [readFile, setReadFile] = useState(companyLogo);

    // State to manage table related working pagination, search and filter etc
    const [state, setState] = useState({
        current: 1,
        limit: 20,
        searchVal: '',
        tabName: 'general',
        tabKey: 4,
        sortBy: 'id',
        sortOrder: 'asc',
    });
    console.log(state, "Burhan state");


    // const [readFile, setReadFile] = useState(null);
    const [img, setimg] = useState(null);
    const [guardCompany, setGuardCompany] = useState(null);
    const [file, setFile] = useState(null);
    const [imageURL, setImageURL] = useState(companyLogo);

    // Drawers maintaining states.
    const [drawerStates, setDrawerStates] = useState({
        openDrawer: false,
        ScheduleDetailDrawer: false,
        EligibilityDetailDrawer: false,
        ScheduleAddDrawer: false,
        EligibilityAddDrawer: false,
        drawerkey: null,
        userid: null,
        actionid: null,
        userDetailDrawer: false,
    });

    const [eventName, setEventName] = useState('');
    const [imgValue, setImageValue] = useState({
        imgSizeValidation: '',
        imgTypeValidation: '',
        isRequired: '',
    });

    // for edit scenerios
    const [editModals, setEditModals] = useState({
        schedule: false,
        eligibilities: false,
        loading: false
    });

    const [editValue, setEditValue] = useState({
        id: null,
        value: ''
    });

    const workWeekRef = useRef(null);

    const handleMasterSave = () => {
        handleSubmit(FormDataHandler)();
    };

    // initial render
    useEffect(() => {
        // dispatch(SettingAction.GetSchedules(state)); // not needed on initial load (General Settings is default)
    }, []);

    // Function to handle tab change
    const handleTabChange = (key) => {
        if (key == 1) {
            setState({
                ...state,
                tabKey: key,
                tabName: 'general',
                current: 1,
                searchVal: '',
                sortOrder: 'asc',
            });
            setDrawerStates({
                ...state,
                drawerkey: null,
                userid: null,
                actionid: null,
            });
            dispatch(
                SettingAction.GetSchedules({
                    ...state,
                    tabKey: key,
                    tabName: 'general',
                    current: 1,
                    searchVal: '',
                    sortOrder: 'asc',
                }),
            );
        }
        else if (key == 2) {
            setState({
                ...state,
                tabKey: key,
                tabName: 'eligibility',
                current: 1,
                searchVal: '',
                sortOrder: 'asc',
            });
            setDrawerStates({
                ...state,
                drawerkey: null,
                userid: null,
                actionid: null,
            });
            dispatch(
                SettingAction.GetEligibilities({
                    ...state,
                    tabKey: key,
                    tabName: 'eligibility',
                    current: 1,
                    searchVal: '',
                    sortOrder: 'asc',
                }),
            );
        }

        else {
            setState({
                ...state,
                tabKey: key,
                tabName: 'general',
                current: 1,
                searchVal: '',
                sortOrder: 'asc',
            });
        }
    };

    // on drawers closes
    const onCloseDrawer = () => {
        if (
            drawerStates?.drawerkey == 1 &&
            drawerStates.EligibilityDetailDrawer
        ) {
            setDrawerStates({
                ...drawerStates,
                EligibilityDetailDrawer: false,
                drawerkey: null,
                userid: null,
                actionid: null,
            });
        } else if (
            drawerStates.drawerkey == 1 &&
            drawerStates.ScheduleDetailDrawer
        ) {
            setDrawerStates({
                ...drawerStates,
                ScheduleDetailDrawer: false,
                drawerkey: null,
                userid: null,
                actionid: null,
            });
        } else {
            setDrawerStates({
                ...drawerStates,
                ScheduleAddDrawer: false,
                EligibilityAddDrawer: false,
            });
        }
    };

    // user Select values filter handler
    const SelectFilterHandler = (value) => {
        setState({ ...state, current: 1, sortOrder: value });
        if (state?.tabKey == 1) {
            dispatch(
                SettingAction.GetSchedules({
                    ...state,
                    current: 1,
                    sortOrder: value,
                }),
            );
            return;
        } else {
            dispatch(
                SettingAction.GetEligibilities({
                    ...state,
                    current: 1,
                    sortOrder: value,
                }),
            );
            return;
        }
    };

    //     if (file) {
    //         const formData = new FormData();
    //         formData.append('file', file);
    //         formData.append('type', 'profile');
    //         const payload = formData;
    //         ApiCaller.Post('/media/upload', payload).then((res) => {
    //             console.log('iddd', res?.data?.data?.id);
    //             if (res.status == 200) {
    //                 // setImageURL(res?.data?.data?.url);
    //                 setImageID(res?.data?.data?.id);
    //             }
    //         });
    //     }
    // }, [file]);
    useEffect(() => {
        // Get stored company data from lo
        if (user?.guardCompany) {
            const {
                name,
                email,
                primaryColour,
                secondaryColour,
                textColour,
                logoId,
                clockInRadiusMeters,
                incidentReportNumberFormat,
                incidentReportNumberCustomPrefix,
            } = user?.guardCompany;
            setValue('name', name || '');
            setValue('email', email || '');
            setValue('primaryColour', primaryColour);
            setValue('secondaryColour', secondaryColour || '#ffffff');
            setValue('textColour', textColour || '#999FE2BF24');
            setValue('logoId', logoId || '');
            setValue('clockInRadiusMeters', clockInRadiusMeters !== undefined && clockInRadiusMeters !== null ? clockInRadiusMeters : '');
            setValue('emergencyAlertEmailEnabled', user?.guardCompany?.emergencyAlertEmailEnabled || false);
            setValue('incidentReportNumberFormat', incidentReportNumberFormat || 'year');
            setValue('incidentReportNumberCustomPrefix', incidentReportNumberCustomPrefix || '');
        }
        setValue('dateFormat', dateFormatFromStore);
        setValue('timeFormat', timeFormatFromStore);
        const nextCompanyLogo = Utils.getBrandLogoUrl(user?.guardCompany);
        setReadFile(nextCompanyLogo);
        setImageURL(nextCompanyLogo);
    }, [setValue, guardCompany, user?.guardCompany]);

    useEffect(() => {
        let fileReader,
            isCancel = false;

        fileReader = new FileReader();
        if (img) {
            fileReader.onload = (e) => {
                setReadFile(e?.target?.result);
            };
            fileReader.readAsDataURL(img);
        }

        return () => {
            isCancel = true;
            if (fileReader && fileReader.readyState === 1) {
                fileReader.abort();
            }
        };
    }, [img]);

    // user Select Values
    const SelectFilterValues = [
        {
            value: 'asc',
            label: 'Ascending',
        },
        {
            value: 'desc',
            label: 'Descending',
        },
    ];

    const items = [
        {
            label: 'View Details',
            key: 1,
            icon: <FaEye color="#6A9BFF" size={18} />,
            backgroundColor: '#eef4ff',
            color: '#4582ff',
        },
        {
            label: "Edit Details",
            key: 2,
            icon: <MdEditDocument color="#E71D36" size={20} />,
            backgroundColor: "#fef3f5",
            color: "#e93148",
        },
    ];

    // schedule Delete -- created but not using it right now as we not deleting any Schedules
    const scheduleDeleteMutation = useMutation(
        async (data) => {
            let res = await ApiCaller.Delete(``);
            return res;
        },
        {
            onSuccess: (res) => {
                Utils.showMessage('success', res?.data?.message);
            },
            onError: (err) => {
                Utils.showMessage('error', err?.response?.data?.message);
            },
        },
    );

    // Schedule action handler
    const ScheduleActionHandler = (e, record) => {
        let id = Number(record?.id);
        if (e.key == '1') {
            setDrawerStates({
                ...drawerStates,
                ScheduleDetailDrawer: true,
                drawerkey: 1,
                actionid: id,
            });
            setEventName(record?.name);
        } else {
            // Delete action
            // scheduleDeleteMutation.mutate(id);

            // edit modal data
            setEditModals({ ...editModals, schedule: true })
            setEditValue({
                id: record?.id,
                value: record?.name
            })
        }
    };

    // Eligibility Delete -- created but not using it right now as we not deleting any Eligibility
    const elegibilityDeleteMutation = useMutation(
        async (data) => {
            let res = await ApiCaller.Delete(``);
            return res;
        },
        {
            onSuccess: (res) => {
                Utils.showMessage('success', res?.data?.message);
            },
            onError: (err) => {
                Utils.showMessage('error', err?.response?.data?.message);
            },
        },
    );

    // Eligibility action handler
    const EligibilityActionHandler = (e, record) => {
        let id = Number(record?.id);
        if (e.key == '1') {
            console.log(id);
            setDrawerStates({
                ...drawerStates,
                EligibilityDetailDrawer: true,
                drawerkey: 1,
                actionid: id,
            });
            setEventName(record?.name);
        } else {
            // Delete action
            // elegibilityDeleteMutation.mutate(id);

            // edit modal data
            setEditModals({ ...editModals, eligibilities: true })
            setEditValue({
                id: record?.id,
                value: record?.name
            })
        }
    };


    // Manage Schedules Columns
    const schedulesColumns = [
        {
            title: 'Name',
            dataIndex: 'name',
            align: 'left',
            render: (text, record) => (
                <Col
                    span={24}
                    className="flex justify-start items-center break-all"
                >
                    <span>{record?.name}</span>
                </Col>
            ),
        },
        // {
        //   title: "Properties",
        //   dataIndex: "Properties",
        //   key: "phone",
        //   render: (text, record) => {
        //     return (
        //       <Col span={24} className="flex justify-start align-center">
        //         <span>{record?.Properties}</span>
        //       </Col>
        //     );
        //   },
        // },
        // {
        //   title: "Assigned Users",
        //   dataIndex: "Assigned Users",
        //   key: "role",
        //   render: (text, record) => {
        //     return (
        //       <Col span={24} className="flex justify-start align-center">
        //         <span>{record['Assigned Users']}</span>
        //       </Col>
        //     );
        //   },
        // },
        {
            title: 'Action',
            dataIndex: 'id',
            align: 'left',
            render: (text, record) => {
                return (
                    <Col span={24} className="flex items-start justify-start">
                        <ActionDropdown
                            items={items}
                            placement={'bottomLeft'}
                            labelStyle={{
                                color: colorPrimary,
                                fontSize: '1.2rem',
                                marginBottom: '7px',
                            }}
                            onClick={(e) => ScheduleActionHandler(e, record)}
                            isRole={isRole}
                        />
                    </Col>
                );
            },
        },
    ];

    // Manage Eligibility COLUMNS
    const eligibilityColumns = [
        {
            title: 'Name',
            dataIndex: 'name',
            align: 'left',
            render: (text, record) => (
                <Col span={24} className="flex justify-start items-center">
                    <span>{record?.name}</span>
                </Col>
            ),
        },
        // {
        //   title: "Assigned Users",
        //   dataIndex: "Assigned Users",
        //   key: "role",
        //   render: (text, record) => {
        //     return (
        //       <Col span={24} className="flex justify-start align-center">
        //         <span>{record['Assigned Users']}</span>
        //       </Col>
        //     );
        //   },
        // },
        {
            title: 'Action',
            dataIndex: 'id',
            align: 'left',
            render: (text, record) => {
                return (
                    <Col
                        span={24}
                        className="flex justify-start align-start"
                        style={{}}
                    >
                        <ActionDropdown
                            items={items}
                            placement={'bottomLeft'}
                            labelStyle={{
                                color: colorPrimary,
                                fontSize: '1.2rem',
                                marginBottom: '7px',
                            }}
                            onClick={(e) => EligibilityActionHandler(e, record)}
                            isRole={isRole}
                        />
                    </Col>
                );
            },
        },
    ];


    const fileHandler = (e) => {
        const file = e?.target.files[0];
        console.log(file);

        if (
            file?.size <= 307200 &&
            ['image/png', 'image/jpeg'].includes(file?.type)
        ) {
            setimg(file);
            setValue('userimg', file);
            setImageValue({
                imgSizeValidation: '',
                imgTypeValidation: '',
                isRequired: '',
            });
            return;
        } else {
            if (file?.size > 307200) {
                setImageValue({
                    ...imgValue,
                    imgSizeValidation: 'Size should not exceed',
                });
                setimg('');
                setValue('userimg', null);
                setReadFile('');
                return;
            } else if (!['image/png', 'image/jpeg'].includes(file?.type)) {
                setImageValue({
                    ...imgValue,
                    imgTypeValidation: 'Type should be either jpeg or png',
                });
                setimg('');
                setValue('userimg', null);
                setReadFile('');
                return;
            }
        }
    };

    const handleEmergencyAlertEmailToggle = async (checked) => {
        try {
            setLoading(true);
            const response = await ApiCaller.Patch(
                '/guard-company/emergency-alert-email-setting',
                { emergencyAlertEmailEnabled: checked }
            );

            if (response.status === 200 || response.status === 201 || response?.data?.data) {
                Utils.showMessage('success', response?.data?.message || 'Emergency alert email setting updated successfully');

                const updatedCompanyData = {
                    ...user.guardCompany,
                    emergencyAlertEmailEnabled: checked
                };

                setGuardCompany(updatedCompanyData);

                const updatedGuardCompany = {
                    ...user,
                    guardCompany: updatedCompanyData,
                };

                localStorage.setItem('user', JSON.stringify(updatedGuardCompany));
                dispatch(AppAction.DataUpdate(updatedGuardCompany));
            } else {
                Utils.showMessage('error', 'Failed to update setting');
                setValue('emergencyAlertEmailEnabled', !checked);
            }
        } catch (error) {
            console.error('Error updating setting:', error);
            Utils.showMessage('error', error?.response?.data?.message || 'Error updating setting');
            setValue('emergencyAlertEmailEnabled', !checked);
        } finally {
            setLoading(false);
        }
    };

    const FormDataHandler = async (data) => {
        console.log('theme data', data);

        // Validate custom prefix when format = custom
        if (data.incidentReportNumberFormat === 'custom') {
            const prefix = (data.incidentReportNumberCustomPrefix || '').trim();
            if (!prefix) {
                Utils.showMessage('error', 'Custom prefix is required when format is set to "Custom Prefix".');
                return;
            }
            if (!/^[A-Za-z0-9_-]+$/.test(prefix)) {
                Utils.showMessage('error', 'Custom prefix may only contain letters, numbers, _ and -.');
                return;
            }
            if (prefix.length > 20) {
                Utils.showMessage('error', 'Custom prefix must not exceed 20 characters.');
                return;
            }
        }

        const payload = {
            name: data.name,
            email: data.email,
            primaryColour: data.primaryColour,
            secondaryColour: data.secondaryColour,
            textColour: data.textColour,
            logoId: data.logoId,
            incidentReportNumberFormat: data.incidentReportNumberFormat || 'year',
            incidentReportNumberCustomPrefix:
                data.incidentReportNumberFormat === 'custom'
                    ? (data.incidentReportNumberCustomPrefix || '').trim()
                    : null,
        };

        try {
            // Set loading to true when the API call starts
            setLoading(true);

            // If there's a logo to upload
            if (data?.userimg && typeof data?.userimg === 'object') {
                const formData = new FormData();
                formData.append('file', data?.userimg); // Append the image file (logo)
                formData.append('type', 'profile'); // Append the type (logo)

                console.log('file form data', formData);

                try {
                    // Upload the logo using the ApiCaller
                    const uploadRes = await ApiCaller.Post(
                        '/media/upload',
                        formData,
                    );
                    if (uploadRes.status === 200 || uploadRes.status === 201) {
                        // If successful, get the logo ID from the response
                        payload.logoId = uploadRes.data?.data?.id; // Update the payload with the new logo ID
                        console.log(
                            'Logo uploaded successfully:',
                            uploadRes.data,
                        );
                    } else {
                        // If upload fails, show error message
                        Utils.showMessage(
                            'error',
                            uploadRes?.data?.message || 'Failed to upload logo',
                        );
                        return; // Exit the function if logo upload fails
                    }
                } catch (err) {
                    // Handle error during the logo upload
                    Utils.showMessage(
                        'error',
                        err?.response?.data?.message || 'Error uploading logo',
                    );
                    return; // Exit the function if logo upload fails
                }
            }

            // Proceed to update the guard company after uploading the logo (if applicable)
            const response = await ApiCaller.Put(
                '/update/guardcompany',
                payload,
            );

            // Update the check-in radius via its specific endpoint
            const radiusValue = data.clockInRadiusMeters !== '' && data.clockInRadiusMeters !== undefined && data.clockInRadiusMeters !== null ? Number(data.clockInRadiusMeters) : null;
            await ApiCaller.Patch(
                '/guard-company/check-in-radius',
                {
                    allowCheckInRadius: radiusValue !== null && radiusValue > 0,
                    clockInRadiusMeters: radiusValue
                }
            );

            // Handle response here
            console.log('Update successful:', response.data?.data);

            if (response?.data?.data) {
                console.log('Guard company updated');

                const updatedCompanyData = {
                    ...response.data.data,
                    allowCheckInRadius: radiusValue !== null && radiusValue > 0,
                    clockInRadiusMeters: radiusValue,
                    // Persist the numbering preview returned by the backend
                    incidentReportNumberFormat: response.data.data.incidentReportNumberFormat || payload.incidentReportNumberFormat,
                    incidentReportNumberCustomPrefix: response.data.data.incidentReportNumberCustomPrefix ?? payload.incidentReportNumberCustomPrefix,
                    incidentReportNumberPreview: response.data.data.incidentReportNumberPreview || null,
                };

                setGuardCompany(updatedCompanyData);

                // Update localStorage with the new guard company data
                const updatedGuardCompany = {
                    ...user,
                    guardCompany: updatedCompanyData,
                };

                console.log('updatedGuardCompany', updatedGuardCompany);

                localStorage.setItem(
                    'user',
                    JSON.stringify(updatedGuardCompany),
                );

                dispatch(AppAction.DataUpdate(updatedGuardCompany));
                dispatch(AppAction.UpdateWeekConfig({ startDay: weekStartDay, endDay: weekEndDay }));

                // Now also save the work week settings
                if (workWeekRef.current && workWeekRef.current.save) {
                    const wwSaved = await workWeekRef.current.save();
                    if (!wwSaved) {
                        setLoading(false);
                        return; // Stop here if validation failed
                    }
                }

                Utils.showMessage('success', response?.data?.message || 'Settings updated successfully');
            }

            // Reset form (optional)
            // reset();
        } catch (error) {
            // Handle error here
            console.error('Error updating company:', error);
            Utils.showMessage(
                'error',
                'An error occurred while updating the company',
            );
        } finally {
            // Set loading to false when the API call finishes
            setLoading(false);
        }
    };

    // const FormDataHandler = async (data) => {
    //     console.log('theme  data', data);
    //     const payload = {
    //         name: data.name,
    //         email: data.email,
    //         primaryColour: data.primaryColour,
    //         secondaryColour: data.secondaryColour,
    //         textColour: data.textColour,
    //         logoId: data.logoId,
    //     };

    //     try {
    //         // Set loading to true when the API call starts
    //         setLoading(true);

    //         // Send PUT request to update guard company
    //         const response = await ApiCaller.Put(
    //             '/update/guardcompany',
    //             payload,
    //         );

    //         // Handle response here
    //         console.log('Update successful:', response.data?.data);

    //         // Assuming response.data contains the updated guard company data
    //         if (response?.data?.data) {
    //             console.log('updatedGuardCompany');
    //             setGuardCompany(response.data.data);

    //             // Update localStorage with the new guard company data
    //             const updatedGuardCompany = {
    //                 ...user,
    //                 guardCompany: response.data.data,
    //             };

    //             console.log('updatedGuardCompanysss', updatedGuardCompany);

    //             localStorage.setItem(
    //                 'user',
    //                 JSON.stringify(updatedGuardCompany),
    //             );

    //             dispatch(AppAction.DataUpdate(updatedGuardCompany));
    //         }

    //         // Reset form (optional)
    //         reset();
    //     } catch (error) {
    //         // Handle error here
    //         console.error('Error updating company:', error);
    //     } finally {
    //         // Set loading to false when the API call finishes
    //         setLoading(false);
    //     }
    // };

    const handlePaginationChange = (page, pageSize) => {
        console.log(page, pageSize);
        setState({ ...state, current: page, limit: pageSize });
        if (state?.tabKey == 1) {
            dispatch(SettingAction.GetSchedules({ ...state, current: page }));
            return;
        } else {
            dispatch(
                SettingAction.GetEligibilities({ ...state, current: page }),
            );
            return;
        }
    };

    const handleDeleteConfirmation = (record) => {
        setRecordToDelete(record);
        setConfirmDeleteVisible(true);
    };

    const debouceHandler = (query, delay) => {
        let timeout;
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            if (state?.tabKey == 1) {
                dispatch(
                    SettingAction.GetSchedules({
                        ...state,
                        searchVal: query,
                        current: 1,
                    }),
                );
            } else {
                dispatch(
                    SettingAction.GetEligibilities({
                        ...state,
                        searchVal: query,
                        current: 1,
                    }),
                );
            }
        }, delay);
    };

    const handleInputChange = (e) => {
        const query = e?.target.value;
        console.log(query);
        setState({ ...state, current: 1, searchVal: e.target.value });
        debouceHandler(query, 2000);
    };

    const handleDeleteConfirm = () => {
        // Perform delete operation here using recordToDelete
        console.log('Deleting record:', recordToDelete);
        setConfirmDeleteVisible(false);
        setRecordToDelete(null);
    };

    const handleDeleteCancel = () => {
        setConfirmDeleteVisible(false);
        setRecordToDelete(null);
    };

    // buttons to open Add schedule and eligibility drawers
    const handleDrawers = () => {
        switch (state?.tabKey) {
            case '1':
                setDrawerStates({ ...drawerStates, ScheduleAddDrawer: true });
                break;
            case '2':
                setDrawerStates({ ...drawerStates, EligibilityAddDrawer: true });
                break;
            default:
                setDrawerStates({ ...drawerStates, ScheduleAddDrawer: true });
                break;
        }
    };

    const handleAddEligibility = () => {
        setDrawerStates({ ...drawerStates, EligibilityAddDrawer: true });
    };

    const handleImageChange = (e) => {
        const file = e.target.files?.[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                if (reader.result) {
                    setImageURL(reader.result);
                }
            };
            reader.readAsDataURL(file);
            setFile(file);
        }
    };

    const deleteImage = () => {
        dispatch(mediaImageNull());
        setImageURL(null);
        setFile(null);
    };

    // edit modal values
    const editValueHandler = (e) => {
        setEditValue((prev) => ({ ...prev, value: e?.target.value }))
    }

    // cancel modal handler
    const cancelModalHandler = () => {
        setEditModals({
            schedule: false,
            eligibilities: false,
            value: ''
        })
    }

    // eligibilities Mutation
    const eligibilitiesMutation = useCallback(useMutation(async () => {
        let payload = {
            name: editValue?.value
        }
        setEditModals((prev) => ({ ...prev, loading: true }))
        let res = await ApiCaller.Patch(`/eligibility/${editValue?.id}`, payload);
        return res;
    },
        {
            onSuccess: (res) => {
                setEditModals((prev) => ({ ...prev, eligibilities: false, loading: false }));
                dispatch(SettingAction.GetEligibilities(state));
                Utils.showMessage('success', res?.data?.message)
            },
            onError: (err) => {
                setEditModals((prev) => ({ ...prev, loading: false }));
                Utils.showMessage('error', err?.response?.data?.message)
            }
        }

    ), [editValue])

    // schedule Mutation
    const schedulesMutation = useCallback(useMutation(async () => {
        let payload = {
            name: editValue?.value
        }
        setEditModals((prev) => ({ ...prev, loading: true }))
        let res = await ApiCaller.Patch(`/schedule/${editValue?.id}`, payload);
        return res;
    },
        {
            onSuccess: (res) => {
                setEditModals((prev) => ({ ...prev, schedule: false, loading: false }));
                dispatch(SettingAction.GetSchedules(state));
                Utils.showMessage('success', res?.data?.message)
            },
            onError: (err) => {
                setEditModals((prev) => ({ ...prev, loading: false }));
                Utils.showMessage('error', err?.response?.data?.message)
            }
        }

    ), [editValue])


    // edit modal handler
    const editServiceHandler = () => {
        // going to call a mutation func here.
        let keyAsString = String(state?.tabKey)
        switch (keyAsString) {
            case '1':
                schedulesMutation.mutate();
                break;
            case '2':
                eligibilitiesMutation.mutate();
                break;
            case '3':
                break;
            default:
                break;
        }
    }

    const sectionCard = {
        background: Colors.White,
        border: '1px solid #e0e4e8',
        borderRadius: '8px',
        padding: '24px',
        marginBottom: '24px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.02)'
    };

    const sectionTitle = {
        fontSize: '16px',
        fontWeight: 600,
        color: '#1a1a1a',
        marginBottom: '20px',
        borderBottom: '1px solid #f0f2f5',
        paddingBottom: '12px'
    };

    const fieldRow = {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '20px',
        marginBottom: '16px'
    };

    const fieldCol = {
        flex: '1 1 200px',
        minWidth: 0
    };

    const labelStyle = {
        display: 'block',
        marginBottom: '6px',
        fontSize: '13px',
        color: Colors.LabelColor,
        fontWeight: 500
    };

    return (
        <>
            <CustomModal
                title="Position Delete"
                open={confirmDeleteVisible}
                cancelModal={handleDeleteCancel}
                centered={true}
                style={{ fontWeight: '500', textAlign: 'center' }}
                Children={
                    <>
                        <div
                            style={{
                                fontWeight: '500',
                                textAlign: 'center',
                                width: '100%',
                            }}
                        >
                            <p
                                style={{
                                    fontWeight: '500',
                                    textAlign: 'center',
                                }}
                            >
                                Are you sure you want to delete?
                            </p>

                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                }}
                            >
                                <div></div>
                                <Button
                                    onClick={handleDeleteConfirm}
                                    style={{
                                        backgroundColor: colorPrimary,
                                        width: '35%',
                                        marginRight: '5%',
                                    }}
                                    type="primary"
                                >
                                    Yes
                                </Button>

                                <Button
                                    onClick={handleDeleteCancel}
                                    style={{
                                        backgroundColor: '#000000',
                                        width: '35%',
                                    }}
                                    type="primary"
                                >
                                    No
                                </Button>
                            </div>
                        </div>
                    </>
                }
            />

            <EligibilityDetailDrawer
                onCloseDrawer={onCloseDrawer}
                drawerStates={drawerStates}
                setDrawerStates={setDrawerStates}
                eventName={eventName}
                isRole={isRole}
                eligibilityData={eligibilitiesData}
                scheduleData={schedulesData}
                rolesData={rolesData}
            />

            <ScheduleDetailDrawer
                onCloseDrawer={onCloseDrawer}
                setDrawerStates={setDrawerStates}
                drawerStates={
                    drawerStates?.ScheduleDetailDrawer && drawerStates
                }
                eventName={eventName}
                isRole={isRole}
                eligibilityData={eligibilitiesData}
                scheduleData={schedulesData}
                rolesData={rolesData}
            />

            <AddScheduleDrawer
                visible={drawerStates.ScheduleAddDrawer}
                onClose={onCloseDrawer}
                setState={setState}
            />

            <AddEligibilityDrawer
                visible={drawerStates.EligibilityAddDrawer}
                onClose={onCloseDrawer}
                setState={setState}
            />

            {/* 
            <NewFilterBar
                btnText1Handler={handleAddSchedule}
                btnText2Handler={handleAddEligibility}
                SelectFilterHandler={SelectFilterHandler}
                handleInputChange={handleInputChange}
                SelectFilterValues={SelectFilterValues}
                defaultValue={'asc'}
                value={state?.sortOrder}
                isRole={isRole}
                SearchValue={state.searchVal}
                title="Setting"
                isManageSchedule={state?.tabKey}
                btnText1={'Add Schedule'}
                btnText2={'Add Eligibility'}
            /> */}
            <TextnFilters
                title="Setting"
                isSearch={(state?.tabKey == '1' || state?.tabKey == '2' || state?.tabKey == '3') ? true : false}
                isSelect={(state?.tabKey == '1' || state?.tabKey == '2' || state?.tabKey == '3') ? true : false}
                isButton={(state?.tabKey == '1' || state?.tabKey == '2' || state?.tabKey == '3') ? true : false}
                defaultValue={'asc'}
                value={state.sortOrder}
                SearchValue={state.searchVal}
                filterOptions={SelectFilterValues}
                SelectFilterHandler={SelectFilterHandler}
                handleInputChange={handleInputChange}
                btnHandler={handleDrawers}
                btnText={(
                    state?.tabKey == '1' ? "Add Schedule" :
                        state?.tabKey == '2' ? 'Add Position' :
                            ''
                )}
            />
            <Row
                gutter={[8, 32]}
                className="w-full"
                style={{
                    background: 'white',
                    padding: '16px',
                    borderRadius: '10px',
                }}
            >
                <Col lg={24} md={24} sm={24} xs={24}>
                    <Row className="w-full">
                        <Col lg={24} md={24} sm={24} xs={24}>
                            <Tabs
                                activeKey={String(state?.tabKey)}
                                defaultActiveKey="4"
                                itemSelectedColor="black"
                                style={{
                                    marginTop: '-4rem',
                                    fontWeight: '500',
                                }}
                                onChange={handleTabChange}
                                items={[
                                    {
                                        label: 'General Settings',
                                        key: '4',
                                        children: (
                                            <>
                                                <Spin spinning={loading} tip="Updating...">
                                                    <form onSubmit={handleSubmit(FormDataHandler)} style={{ width: '100%' }}>

                                                        <Collapse
                                                            defaultActiveKey={[]}
                                                            expandIconPosition="end"
                                                            style={{ marginBottom: '24px', background: 'transparent', border: 'none' }}
                                                            items={[
                                                                {
                                                                    key: '1',
                                                                    label: <span style={{ fontSize: '16px', fontWeight: 600, color: '#1a1a1a' }}>Company Profile & Theme Global Setup</span>,
                                                                    style: sectionCard,
                                                                    children: (
                                                                        <div style={{ paddingTop: '8px' }}>

                                                                            {/* Row 1: Avatar + Company Name + Email */}
                                                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', alignItems: 'flex-start', marginBottom: 20 }}>
                                                                                {/* Avatar */}
                                                                                <div style={{ flexShrink: 0 }}>
                                                                                    <div style={{ position: 'relative', width: 88, height: 88, borderRadius: '50%', background: '#F0F2F5', border: '2px solid #e0e4e8', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', overflow: 'visible' }}>
                                                                                        <Controller
                                                                                            control={control}
                                                                                            name="userimg"
                                                                                            defaultValue=""
                                                                                            render={(field, fieldState) => (
                                                                                                <input
                                                                                                    type="file"
                                                                                                    style={{ position: 'absolute', inset: 0, opacity: 0, cursor: 'pointer', borderRadius: '50%', zIndex: 10, width: '100%', height: '100%' }}
                                                                                                    onChange={(e) => fileHandler(e)}
                                                                                                    accept=".png,.jpg,.jpeg"
                                                                                                />
                                                                                            )}
                                                                                        />
                                                                                        {readFile ? (
                                                                                            <>
                                                                                                <Avatar src={readFile} style={{ width: 88, height: 88, position: 'absolute', inset: 0, zIndex: 5 }} />
                                                                                                {/* Pencil icon when logo is present */}
                                                                                                <span style={{ position: 'absolute', bottom: 4, right: 4, color: '#fff', fontSize: 13, zIndex: 15, background: colorPrimary, borderRadius: '50%', width: 24, height: 24, display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 1px 4px rgba(0,0,0,0.18)' }}>
                                                                                                    ✎
                                                                                                </span>
                                                                                            </>
                                                                                        ) : (
                                                                                            <Avatar icon={<FaCamera />} style={{ width: 88, height: 88, position: 'absolute', inset: 0, zIndex: 5 }} />
                                                                                        )}
                                                                                    </div>
                                                                                    {imgValue?.imgSizeValidation && <p style={{ color: Colors.Error, fontSize: 11, margin: '4px 0 0', textAlign: 'center' }}>{imgValue.imgSizeValidation}</p>}
                                                                                    {imgValue?.imgTypeValidation && <p style={{ color: Colors.Error, fontSize: 11, margin: '4px 0 0', textAlign: 'center' }}>{imgValue.imgTypeValidation}</p>}
                                                                                </div>

                                                                                {/* Company Name */}
                                                                                <div style={{ flex: '1 1 200px' }}>
                                                                                    <Controller
                                                                                        name="name"
                                                                                        control={control}
                                                                                        render={({ field }) => (
                                                                                            <LabelWithField
                                                                                                labeltext="Company Name"
                                                                                                field={field}
                                                                                                inputClass="py-3 px-1 rounded-md"
                                                                                            />
                                                                                        )}
                                                                                    />
                                                                                </div>

                                                                                {/* Email */}
                                                                                <div style={{ flex: '1 1 200px' }}>
                                                                                    <Controller
                                                                                        name="email"
                                                                                        control={control}
                                                                                        render={({ field }) => (
                                                                                            <LabelWithField
                                                                                                labeltext="Email"
                                                                                                field={field}
                                                                                                inputClass="py-3 px-1 rounded-md"
                                                                                                disabled={true}
                                                                                            />
                                                                                        )}
                                                                                    />
                                                                                </div>
                                                                            </div>

                                                                            {/* Row 2: Three colour pickers */}
                                                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', alignItems: 'flex-start' }}>
                                                                                {[
                                                                                    { name: 'primaryColour', label: 'Primary Colour' },
                                                                                    { name: 'secondaryColour', label: 'Secondary Colour' },
                                                                                    { name: 'textColour', label: 'Text Colour' },
                                                                                ].map(({ name: fieldName, label }) => (
                                                                                    <div key={fieldName} style={{ flex: '1 1 200px' }}>
                                                                                        <label style={{ display: 'block', marginBottom: 6, fontSize: 13, color: Colors.LabelColor, fontWeight: 500 }}>
                                                                                            {label}
                                                                                        </label>
                                                                                        <Space direction="vertical" className="w-full" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 8 }}>
                                                                                            <ColorPicker
                                                                                                value={control._formValues[fieldName]}
                                                                                                onChange={(color) => {
                                                                                                    const hex = color.toHexString();
                                                                                                    if (hex.toLowerCase() !== '#ffffff' && hex.toLowerCase() !== '#ffffffff') {
                                                                                                        control._subjects.values.next({ ...control._formValues, [fieldName]: hex });
                                                                                                        control.setValue && control.setValue(fieldName, hex, { shouldValidate: true, shouldDirty: true });
                                                                                                    }
                                                                                                }}
                                                                                                onChangeComplete={(color) => {
                                                                                                    const hex = color.toHexString();
                                                                                                    if (hex.toLowerCase() === '#ffffff' || hex.toLowerCase() === '#ffffffff') {
                                                                                                        Utils.showMessage('warning', 'White is not allowed as a theme colour');
                                                                                                    }
                                                                                                }}
                                                                                            />
                                                                                            <Controller
                                                                                                name={fieldName}
                                                                                                control={control}
                                                                                                render={({ field }) => (
                                                                                                    <Input value={field.value} readOnly style={{ flex: 1 }} />
                                                                                                )}
                                                                                            />
                                                                                        </Space>
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        </div>
                                                                    ),
                                                                },
                                                                {
                                                                    key: '2',
                                                                    label: <span style={{ fontSize: '16px', fontWeight: 600, color: '#1a1a1a' }}>Date/Time & Work Week</span>,
                                                                    style: sectionCard,
                                                                    children: (
                                                                        <div style={{ paddingTop: '8px' }}>

                                                                            {/* Date & Time Format Row */}
                                                                            <div style={fieldRow}>
                                                                                <div style={fieldCol}>
                                                                                    <label style={labelStyle}>Date Format</label>
                                                                                    <Controller
                                                                                        name="dateFormat"
                                                                                        control={control}
                                                                                        defaultValue={dateFormatFromStore}
                                                                                        render={({ field }) => (
                                                                                            <Select
                                                                                                {...field}
                                                                                                className="w-full h-10"
                                                                                                placeholder="Select Date Format"
                                                                                                onChange={(val) => {
                                                                                                    field.onChange(val);
                                                                                                    dispatch(AppAction.UpdateDateFormat({ dateFormat: val, timeFormat: timeFormatFromStore }));
                                                                                                }}
                                                                                                options={[
                                                                                                    { value: 'MM/DD/YYYY', label: 'MM/DD/YYYY (US/Default)' },
                                                                                                    { value: 'DD/MM/YYYY', label: 'DD/MM/YYYY (UK/Europe)' },
                                                                                                    { value: 'YYYY-MM-DD', label: 'YYYY-MM-DD (ISO)' },
                                                                                                    { value: 'MMM DD, YYYY', label: 'MMM DD, YYYY (Descriptive)' },
                                                                                                ]}
                                                                                            />
                                                                                        )}
                                                                                    />
                                                                                </div>
                                                                                <div style={fieldCol}>
                                                                                    <label style={labelStyle}>Time Format</label>
                                                                                    <Controller
                                                                                        name="timeFormat"
                                                                                        control={control}
                                                                                        defaultValue={timeFormatFromStore}
                                                                                        render={({ field }) => (
                                                                                            <Select
                                                                                                {...field}
                                                                                                className="w-full h-10"
                                                                                                placeholder="Select Time Format"
                                                                                                onChange={(val) => {
                                                                                                    field.onChange(val);
                                                                                                    dispatch(AppAction.UpdateDateFormat({ dateFormat: dateFormatFromStore, timeFormat: val }));
                                                                                                }}
                                                                                                options={[
                                                                                                    { value: 'hh:mm A', label: '12-hour (hh:mm AM/PM)' },
                                                                                                    { value: 'HH:mm', label: '24-hour (HH:mm)' },
                                                                                                ]}
                                                                                            />
                                                                                        )}
                                                                                    />
                                                                                </div>
                                                                            </div>

                                                                            {/* Work Week Component */}
                                                                            <div style={{ marginTop: '16px' }}>
                                                                                {isRole === 'superadmin' ? (
                                                                                    <SuperAdminWorkWeekSettings ref={workWeekRef} />
                                                                                ) : (
                                                                                    <CompanyWorkWeekSettings ref={workWeekRef} />
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    ),
                                                                },
                                                                {
                                                                    key: '3',
                                                                    label: <span style={{ fontSize: '16px', fontWeight: 600, color: '#1a1a1a' }}>Check-In Radius & Emergency Alert</span>,
                                                                    style: sectionCard,
                                                                    children: (
                                                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 20, alignItems: 'flex-start', paddingTop: '8px' }}>
                                                                            <div style={{ flex: '1 1 250px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                                                                <h3 style={{ fontSize: '14px', fontWeight: 600, marginBottom: '16px', color: '#1a1a1a' }}>Check-In Radius</h3>
                                                                                <Controller
                                                                                    name="clockInRadiusMeters"
                                                                                    control={control}
                                                                                    render={({ field }) => (
                                                                                        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                                                                            <LabelWithField
                                                                                                labeltext="Check-In Radius (meters) By Default 600 meters set"
                                                                                                type="number"
                                                                                                field={field}
                                                                                                inputClass="py-3 px-1 rounded-md"
                                                                                                placeholder="Enter radius in meters"
                                                                                            />
                                                                                            <p style={{ color: Colors.LabelColor, fontSize: '0.8rem', marginTop: -10 }}>
                                                                                                Set the allowed check-in and check-out radius.
                                                                                            </p>
                                                                                        </div>
                                                                                    )}
                                                                                />
                                                                            </div>
                                                                            <div style={{ flex: '1 1 250px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                                                                <h3 style={{ fontSize: '14px', fontWeight: 600, marginBottom: '16px', color: '#1a1a1a' }}>Emergency Alert Email</h3>
                                                                                <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingTop: 8 }}>
                                                                                    <div>
                                                                                        <p style={{ fontWeight: 500, color: Colors.LabelColor, margin: 0, fontSize: 13 }}>Emergency Alert Email</p>
                                                                                        <p style={{ color: Colors.LabelColor, fontSize: '0.8rem', margin: 0, marginTop: 4 }}>
                                                                                            Enable or disable emergency alert emails.
                                                                                        </p>
                                                                                    </div>
                                                                                    <Controller
                                                                                        name="emergencyAlertEmailEnabled"
                                                                                        control={control}
                                                                                        render={({ field }) => (
                                                                                            <Switch
                                                                                                checked={field.value}
                                                                                                onChange={(checked) => {
                                                                                                    field.onChange(checked);
                                                                                                    handleEmergencyAlertEmailToggle(checked);
                                                                                                }}
                                                                                            />
                                                                                        )}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ),
                                                                },
                                                                {
                                                                    key: '4',
                                                                    label: <span style={{ fontSize: '16px', fontWeight: 600, color: '#1a1a1a' }}>Incident Report Numbering</span>,
                                                                    style: sectionCard,
                                                                    children: (
                                                                        <div style={{ paddingTop: '8px' }}>
                                                                            {/* Format + Custom Prefix on same row */}
                                                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', alignItems: 'flex-start' }}>
                                                                                {/* Format dropdown - takes half width */}
                                                                                <div style={{ flex: '1 1 200px' }}>
                                                                                    <label style={labelStyle}>Report Number Format</label>
                                                                                    <Controller
                                                                                        name="incidentReportNumberFormat"
                                                                                        control={control}
                                                                                        defaultValue="year"
                                                                                        render={({ field }) => (
                                                                                            <Select
                                                                                                {...field}
                                                                                                className="w-full h-10"
                                                                                                options={[
                                                                                                    { value: 'year', label: 'Year  (e.g. 2026-001)' },
                                                                                                    { value: 'year_month', label: 'Year-Month  (e.g. 2026-07-001)' },
                                                                                                    { value: 'custom', label: 'Custom Prefix  (e.g. OPS-001)' },
                                                                                                ]}
                                                                                            />
                                                                                        )}
                                                                                    />
                                                                                </div>

                                                                                {/* Custom prefix — shown only when format = custom */}
                                                                                {watch('incidentReportNumberFormat') === 'custom' ? (
                                                                                    <div style={{ flex: '1 1 200px' }}>
                                                                                        <label style={labelStyle}>Custom Prefix</label>
                                                                                        <Controller
                                                                                            name="incidentReportNumberCustomPrefix"
                                                                                            control={control}
                                                                                            render={({ field }) => (
                                                                                                <Input
                                                                                                    {...field}
                                                                                                    placeholder="e.g. OPS (max 20 chars)"
                                                                                                    maxLength={20}
                                                                                                    className="w-full h-10"
                                                                                                />
                                                                                            )}
                                                                                        />
                                                                                        <p style={{ color: Colors.LabelColor, fontSize: '0.75rem', marginTop: 4 }}>
                                                                                            Allowed: letters, numbers, _ and -
                                                                                        </p>
                                                                                    </div>
                                                                                ) : (
                                                                                    <div style={{ flex: 1 }} />
                                                                                )}
                                                                            </div>

                                                                            {/* Live preview badge */}
                                                                            {user?.guardCompany?.incidentReportNumberPreview && (
                                                                                <div style={{ marginTop: 12, display: 'flex', alignItems: 'center', gap: 10 }}>
                                                                                    <span style={{ fontSize: 13, color: Colors.LabelColor, fontWeight: 500 }}>
                                                                                        Preview:
                                                                                    </span>
                                                                                    <span style={{
                                                                                        display: 'inline-block',
                                                                                        background: colorPrimary + '18',
                                                                                        color: colorPrimary,
                                                                                        border: `1px solid ${colorPrimary}44`,
                                                                                        borderRadius: 6,
                                                                                        padding: '2px 14px',
                                                                                        fontWeight: 600,
                                                                                        fontSize: 14,
                                                                                        letterSpacing: 0.5,
                                                                                    }}>
                                                                                        {user.guardCompany.incidentReportNumberPreview}
                                                                                    </span>
                                                                                    <span style={{ fontSize: 12, color: Colors.LabelColor }}>
                                                                                        — next generated report number
                                                                                    </span>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    ),
                                                                },
                                                                {
                                                                    key: '5',
                                                                    label: <span style={{ fontSize: '16px', fontWeight: 600, color: '#1a1a1a' }}>Contact Directory</span>,
                                                                    style: sectionCard,
                                                                    children: (
                                                                        <div style={{ paddingTop: '8px' }}>
                                                                            <ContactDirectoryPage />
                                                                        </div>
                                                                    ),
                                                                },
                                                                ...(isRole === 'admin' ? [{
                                                                    key: '6',
                                                                    label: <span style={{ fontSize: '16px', fontWeight: 600, color: '#1a1a1a' }}>Patrol Settings</span>,
                                                                    style: sectionCard,
                                                                    children: (
                                                                        <div style={{ paddingTop: '8px' }}>
                                                                            <PatrolSettingsPage insideSettings />
                                                                        </div>
                                                                    ),
                                                                }] : [])
                                                            ]}
                                                        />

                                                    </form>

                                                    {/* ── Master Save button ── */}
                                                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 10, marginBottom: 24 }}>
                                                        <Button
                                                            onClick={handleMasterSave}
                                                            type="primary"
                                                            style={{ background: colorPrimary, color: '#fff', border: 'none', borderRadius: 6, height: 44, padding: '0 40px', fontWeight: 600, fontSize: 16, cursor: 'pointer', letterSpacing: 0.4 }}
                                                        >
                                                            Save
                                                        </Button>
                                                    </div>
                                                </Spin>
                                            </>
                                        ),
                                    },
                                    ...(isRole === 'admin' || isRole === 'superadmin' ? [{
                                        label: 'Reports & Email',
                                        key: '5',
                                        children: (
                                            <ScheduledReportsSettings />
                                        ),
                                    }] : []),
                                    {
                                        label: 'Manage Schedule',
                                        key: '1',
                                        children: (
                                            <>
                                                <TableWrapper
                                                    tableStyle={{
                                                        borderRadius: '40px',
                                                        width: '100%',
                                                    }}
                                                    headerbg={'red'}
                                                    tableColumns={
                                                        schedulesColumns
                                                    }
                                                    tableData={schedules}
                                                    total={
                                                        schedulesPagination?.total
                                                    }
                                                    pageSize={state.limit}
                                                    currentPage={state.current}
                                                    handlePaginationChange={
                                                        handlePaginationChange
                                                    }
                                                    loading={loader && <Spin />}
                                                    rowClassName={'row-antd'}
                                                />
                                            </>
                                        ),
                                    },
                                    {
                                        label: 'Manage Position',
                                        key: '2',
                                        children: (
                                            <>
                                                <TableWrapper
                                                    tableStyle={{
                                                        borderRadius: '40px',
                                                        width: '100%',
                                                    }}
                                                    headerbg={'red'}
                                                    tableColumns={
                                                        eligibilityColumns
                                                    }
                                                    tableData={elegibilities}
                                                    total={
                                                        elegibilityPagination?.total
                                                    }
                                                    pageSize={state.limit}
                                                    currentPage={state.current}
                                                    handlePaginationChange={
                                                        handlePaginationChange
                                                    }
                                                    loading={loader && <Spin />}
                                                    rowClassName={'row-antd'}
                                                />
                                            </>
                                        ),
                                    },

                                ]}
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>

            <Modal.Basic
                open={editModals.eligibilities || editModals.schedule}
                centered
                width={300}
                title=''
                onCancel={cancelModalHandler}
                Children={
                    <div className='flex flex-col gap-5'>
                        <h1 className='text-center font-semibold text-lg'>
                            Edit {state?.tabName?.at(0)?.toUpperCase() + state?.tabName?.slice(1)} Name
                        </h1>
                        <input
                            type='text'
                            value={editValue?.value}
                            onChange={editValueHandler}
                            className='border py-2 outline-none px-1 text-md rounded-md bg-slate-100 mx-4'
                        />
                        <Button
                            onClick={editServiceHandler}
                            style={{
                                backgroundColor: colorPrimary,
                            }}
                            loading={editModals?.loading}
                            // type={"primary"}
                            className={`w-[90%] mx-auto text-white`}
                        >
                            Save
                        </Button>
                    </div>
                }
            />
        </>
    );
};

// const columns = [
//     {
//       title: 'Name',
//       dataIndex: 'name',
//       key: 'name',
//     },
//     {
//       title: 'Properties',
//       dataIndex: 'Properties',
//       key: 'Properties',
//     },
//     {
//       title: 'AssignedUsers',
//       dataIndex: 'AssignedUsers',
//       key: 'AssignedUsers',
//     },
//     {
//       title: 'Action',
//       dataIndex: 'Action',
//       key: 'Action',
//     },
//   ];

export default Settings;
